import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Table, Button, Space, Tag, Popconfirm, message } from 'antd';

const { Title, Paragraph } = Typography;

const CampaignApprovals = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const load = async () => {
    setLoading(true);
    try {
      // Placeholder data; replace with GET /api/campaigns?status=pending or a dedicated approvals endpoint
      const mock = [
        { id: 801, name: 'Back-to-School', client: 'Contoso Retail', requested_by: 'alice@contoso.com', status: 'pending', requested_at: '2025-08-10 10:32' },
        { id: 802, name: 'Autumn Promo', client: 'Tailwind Co', requested_by: 'ops@tailwind.co', status: 'pending', requested_at: '2025-08-12 14:09' },
      ];
      setData(mock);
    } catch (e) {
      message.error(e.message || 'Failed to load approval queue');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const onApprove = async (record) => {
    try {
      // Replace with PUT /api/campaigns/:id approve action
      await new Promise(r => setTimeout(r, 300));
      message.success(`Approved campaign #${record.id}`);
      setData(prev => prev.filter(c => c.id !== record.id));
    } catch (e) {
      message.error(e.message || 'Approval failed');
    }
  };

  const onReject = async (record) => {
    try {
      // Replace with PUT /api/campaigns/:id reject action
      await new Promise(r => setTimeout(r, 300));
      message.success(`Rejected campaign #${record.id}`);
      setData(prev => prev.filter(c => c.id !== record.id));
    } catch (e) {
      message.error(e.message || 'Rejection failed');
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 90 },
    { title: 'Campaign', dataIndex: 'name', key: 'name' },
    { title: 'Client', dataIndex: 'client', key: 'client' },
    { title: 'Requested By', dataIndex: 'requested_by', key: 'requested_by' },
    { title: 'Requested At', dataIndex: 'requested_at', key: 'requested_at', width: 180 },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s) => (
        <Tag color={s === 'pending' ? 'orange' : s === 'approved' ? 'green' : 'red'}>{s}</Tag>
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Popconfirm title="Approve this campaign?" onConfirm={() => onApprove(record)} okText="Approve" okButtonProps={{ type: 'primary' }}>
            <Button size="small" type="primary">Approve</Button>
          </Popconfirm>
          <Popconfirm title="Reject this campaign?" onConfirm={() => onReject(record)} okText="Reject" okButtonProps={{ danger: true }}>
            <Button size="small" danger>Reject</Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[
        { title: 'Admin' },
        { title: 'Campaigns' },
        { title: 'Approval Queue' },
      ]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Campaign Approval Queue</Title>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>
          Approve or reject pending campaign requests. Replace mock logic with your backend endpoints.
        </Paragraph>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{ pageSize: 10 }}
        />
      </Card>
    </div>
  );
};

export default CampaignApprovals;
